import { Button, Card, Tabs, TabsProps } from "antd";
import React from "react";
import StudioSettingsCard from "../component/Cards/StudioSettingsCard";
import AppHeader from "../layouts/header";
import YoutubeChannels from "../component/youtube/youtubeChannels";

const Settings = () => {
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Studio Settings",
      children: <StudioSettingsCard />,
    },
    {
      key: "2",
      label: "Youtube Settings",
      children: <YoutubeChannels />,
    },
  ];

  return (
    <div>
      <AppHeader />
      <Card title="Settings" type="inner">
        <Tabs
          defaultActiveKey="1"
          items={items}
          tabBarExtraContent={
            <Button
              type="primary"
              onClick={() =>
                window.open(
                  "https://studio-api-dev.kgs.live/admin/queues",
                  "_blank",
                )
              }
            >
              View Jobs
            </Button>
          }
        />
      </Card>
    </div>
  );
};

export default Settings;
